/**
 * Turn a slug-like agent id into readable text (e.g. `imo_agent` → "Imo Agent").
 *
 * @param {string} id
 * @returns {string | null}
 */
export function humanizeAgentId(id) {
  const s = String(id)
    .trim()
    .replace(/[-_]+/g, ' ')
    .replace(/\s+/g, ' ');
  if (!s) {
    return null;
  }
  return s.replace(/\b\w/g, (c) => c.toUpperCase());
}

/**
 * @param {unknown} v
 * @returns {string | null}
 */
function nonEmptyTrimmedString(v) {
  if (typeof v !== 'string' || v.trim() === '') {
    return null;
  }
  return v.trim();
}

/**
 * Human-facing agent label for the welcome line and chat header (from GET config).
 * Prefers `agent.displayName`, then `agent.name`, then a readable form of the agent id.
 *
 * @param {Record<string, unknown> | null} config
 * @returns {string | null}
 */
export function resolveWelcomeAgentDisplayName(config) {
  if (!config || typeof config !== 'object') {
    return null;
  }
  const agent = config.agent;
  const fromDisplay =
    agent && typeof agent === 'object'
      ? nonEmptyTrimmedString(agent.displayName)
      : null;
  if (fromDisplay) {
    return fromDisplay;
  }
  const fromName =
    agent && typeof agent === 'object'
      ? nonEmptyTrimmedString(agent.name)
      : null;
  if (fromName) {
    return fromName;
  }
  const rawId = config.agentId || (agent && typeof agent === 'object' ? agent.id : null);
  if (typeof rawId === 'string' && rawId.trim() !== '') {
    return humanizeAgentId(rawId);
  }
  return null;
}
